import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import contractorActions from "../../../../_actions/contractorActions";
import projActions from "../../../../_actions/projActions";

class EditProjContractorModal extends Component {
  state = {
    formData: {
      contractorId: 0,
      projectId: 0,
      name: "", // Disabled from editing
      abbreviation: "", // Disabled from editing
      projectAbbreviation: "",
      isPrime: false, // Disabled from editing
      contactFullName: "",
      contactTitle: "",
      phone: "",
      address: "",
      isJointVenture: false, // Disabled from editing
    },
    formErrors: {
      projectAbbreviation: null,
    },
  };

  componentDidMount() {
    const { projContractor: pc } = this.props;
    this.setState({
      formData: {
        contractorId: pc.contractorId,
        projectId: pc.projectId,
        name: pc.name,
        abbreviation: pc.abbreviation,
        projectAbbreviation: pc.projectAbbreviation || pc.abbreviation,
        isPrime: pc.isPrime,
        contactFullName: pc.contactFullName,
        contactTitle: pc.contactTitle,
        phone: pc.phone,
        address: pc.address,
        isJointVenture: pc.isJointVenture,
      },
    });
  }

  handleChange = (e) => {
    const fieldName = e.target.name;
    this.setState(
      {
        formData: { ...this.state.formData, [fieldName]: e.target.value },
      },
      () => this.validateForm(fieldName)
    );
  };

  handleChange_check = (e) =>
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.checked },
    });

  handleBlur = (e) => this.validateForm(e.target.name);

  validateForm = (fieldName) => {
    const { formData } = this.state;
    const formErrors = { ...this.state.formErrors };
    switch (fieldName) {
      case "projectAbbreviation":
        if (!formData.projectAbbreviation) formErrors.projectAbbreviation = "Required";
        else formErrors.projectAbbreviation = null;
        break;
      default:
        break;
    }
    this.setState({ formErrors });
  };

  formIsIncomplete = () => {
    const { formData, formErrors } = this.state;
    return !formData.projectAbbreviation || formErrors.projectAbbreviation;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { dispatch, projectId, contractorId, toggleEditPcDetailsModal } = this.props;
    const formData = { ...this.state.formData };
    if (!this.formIsIncomplete()) {
      await dispatch(contractorActions.updateProjectContractorDetails(formData));
      toggleEditPcDetailsModal();
      dispatch(projActions.getContractorDetails(projectId, contractorId));
    }
  };

  render() {
    const { formData, formErrors } = this.state;
    const { showEditPcDetailsModal, toggleEditPcDetailsModal } = this.props;
    const closeBtn = (
      <button className="close" onClick={toggleEditPcDetailsModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <React.Fragment>
        <Modal
          isOpen={showEditPcDetailsModal}
          toggle={toggleEditPcDetailsModal}
          className={this.props.className}
          size={"lg"}
          fade={false}
        >
          <ModalHeader
            toggle={toggleEditPcDetailsModal}
            className="bg-info text-white"
            close={closeBtn}
          >
            <FontAwesomeIcon icon="edit" className="fa-fw mr-2" />
            Edit Contractor Info
          </ModalHeader>
          <ModalBody>
            <div className="card m-2">
              <div className="card-body">
                <div className="form-row form-group mb-2">
                  <label htmlFor="name" className="col-sm-3 col-form-label">
                    Name:
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      className="form-control"
                      maxLength="50"
                      value={formData.name || ""}
                      onChange={this.handleChange}
                      disabled
                    />
                  </div>
                </div>
                <div className="form-row form-group mb-2">
                  <label
                    htmlFor="projectAbbreviation"
                    className="col-sm-3 col-form-label"
                  >
                    <b>Abbrev.:</b>*
                  </label>
                  <div className="col-sm-5">
                    <input
                      type="text"
                      name="projectAbbreviation"
                      id="projectAbbreviation"
                      className="form-control"
                      maxLength="5"
                      value={formData.projectAbbreviation || ""}
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                    />
                    {formErrors.projectAbbreviation && (
                      <span className="error-small">
                        <small>{formErrors.projectAbbreviation}</small>
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-row form-group mb-2">
                  <div className="col-sm-3 my-auto"></div>
                  <div className="col-sm-9">
                    <div className="custom-control-inline custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        name="isPrime"
                        id="isPrime"
                        className="custom-control-input my-auto"
                        value={formData.isPrime}
                        checked={formData.isPrime}
                        onChange={this.handleChange_check}
                        disabled
                      />
                      <label htmlFor="isPrime" className="custom-control-label my-auto">
                        <b>Prime</b>{" "}
                        <small>
                          (Prime status can be changed from the contractor selection
                          modal.)
                        </small>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-row form-group mb-2">
                  <div className="col-sm-3 my-auto"></div>
                  <div className="col-sm-9">
                    <div className="custom-control-inline custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        name="isJointVenture"
                        id="isJointVenture"
                        className="custom-control-input my-auto"
                        value={formData.isJointVenture}
                        checked={formData.isJointVenture}
                        onChange={this.handleChange_check}
                        disabled
                      />
                      <label
                        htmlFor="isJointVenture"
                        className="custom-control-label my-auto"
                      >
                        Joint venture
                      </label>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                    <h6 className="text-muted mb-3">Contacts (For This Project):</h6>
                    <div className="form-row form-group mb-2">
                      <label
                        htmlFor="contactFullName"
                        className="col-sm-3 col-form-label"
                      >
                        Contact Name:
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          name="contactFullName"
                          id="contactFullName"
                          className="form-control"
                          maxLength="100"
                          value={formData.contactFullName}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-row form-group mb-2">
                      <label htmlFor="contactTitle" className="col-sm-3 col-form-label">
                        Contact Title:
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          name="contactTitle"
                          id="contactTitle"
                          className="form-control"
                          maxLength="50"
                          value={formData.contactTitle}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-row form-group mb-2">
                      <label htmlFor="phone" className="col-sm-3 col-form-label">
                        Phone:
                      </label>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          name="phone"
                          id="phone"
                          className="form-control"
                          maxLength="15"
                          value={formData.phone}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-row form-group">
                      <label htmlFor="address" className="col-sm-3 col-form-label">
                        Address:
                      </label>
                      <div className="col-sm-6">
                        <textarea
                          name="address"
                          id="address"
                          className="form-control"
                          maxLength="200"
                          rows="2"
                          value={formData.address}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="bg-lightgray">
            <div className="form-row form-group mb-0">
              <button
                type="button"
                className="btn btn-primary"
                name="editPcDetailsSubmit"
                onClick={this.handleSubmit}
                disabled={this.formIsIncomplete()}
              >
                Save
              </button>{" "}
              <button
                className="btn btn-secondary ml-2"
                color="secondary"
                onClick={toggleEditPcDetailsModal}
              >
                Cancel
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  projContractor: state.contractors.openProjContractorDetails[ownProps.projectId]
    ? state.contractors.openProjContractorDetails[ownProps.projectId][
        ownProps.contractorId
      ] || null
    : null,
});

export default connect(mapStateToProps)(EditProjContractorModal);
